import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12c35de7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "app",
  class: "view-container main",
  role: "main"
}
const _hoisted_2 = { class: "visually-hidden" }
const _hoisted_3 = { class: "container-fluid em-page-grid px-0" }
const _hoisted_4 = { class: "px-0 d-flex flex-column-reverse flex-md-column" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "iframe-helper-height-fix" }, null, -1))

import { defineAsyncComponent, onMounted } from 'vue';
import { APP_LOCALE } from '@/i18n/constants';
import { isDefined } from '@/utils';
import type { Locale } from '@/i18n/models';
import { RouterView } from 'vue-router';
import { useI18nStore } from '@/stores/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isProduction = process.env.NODE_ENV === 'production';
const DeveloperPanel = defineAsyncComponent(() => import('@/components/DeveloperPanel/DeveloperPanel.vue'));

onMounted(() => {
  const locale = sessionStorage.getItem(APP_LOCALE) as Locale | null;
  if (isDefined(locale)) useI18nStore().set(locale);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('title:long')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(RouterView)),
          (!isProduction)
            ? (_openBlock(), _createBlock(_unref(DeveloperPanel), { key: 0 }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_5
  ], 64))
}
}

})